import { Component, OnInit } from '@angular/core';
import { DataService } from '../data.service';
import * as SurveyKo from "survey-knockout";
import * as SurveyCreator from "survey-creator";
import { ActivatedRoute, Router } from "@angular/router";
import { MessageService } from 'primeng/api';

SurveyCreator.StylesManager.applyTheme("default");

@Component({
  selector: 'app-editarformulario-promociones',
  templateUrl: './editarformulario-promociones.component.html',
  styleUrls: ['./editarformulario-promociones.component.css']
})
export class EditarformularioPromocionesComponent implements OnInit {

  grabaraudio: boolean = false;
  agregarsujeto: boolean = false;
  campoidentificador: string = '';
  campodescripcion: string = '';

  json: any;
  surveyCreator: any;

  promocionId: any = '';
  formularioId: any = '';
  Nombre: any;
  Descripcion: any;
  formulario: any = {};
  private extraerFormulario(res: any) {
    if (!res) return null;
    if (res.Definicion) return res;
    if (res.formulario) return res.formulario;
    if (res.Formulario) return res.Formulario;
    if (Array.isArray(res)) return res[0];
    if (Array.isArray(res?.registros)) return res.registros[0];
    return res;
  }

  constructor(public data: DataService, private route: ActivatedRoute, private router: Router, private messageService: MessageService) {
    const promoParam = this.route.snapshot.queryParamMap.get('promocion');
    this.promocionId = promoParam ?? '';
    console.log('editarformulario-promociones promocion:', this.promocionId);
  }

  ngOnInit(): void {
    if (!this.promocionId) {
      this.json = {};
      return;
    }

    const promoNum = Number(this.promocionId);
    const payloadPromo = isNaN(promoNum) ? this.promocionId : promoNum;

    // Cargar formulario por promoción (payload { promocion: numero })
    this.data.ObtenerFormularioPorPromocion(payloadPromo).subscribe(x => {
      console.log('ObtenerFormularioPorPromocion respuesta:', x);
      this.formulario = this.extraerFormulario(x) || {};
      // Asumimos misma estructura que ObtenerFormulario
      this.formularioId = (this.formulario as any)?._id || (this.formulario as any)?.id || payloadPromo;
      this.json = this.formulario["Definicion"];
      this.Nombre = this.formulario["Definicion"]?.["title"];
      this.Descripcion = this.formulario["Definicion"]?.["description"];
      this.agregarsujeto = this.formulario["AgregarSujeto"];
      this.campoidentificador = this.formulario["CampoIdentificador"];
      this.campodescripcion = this.formulario["CampoDescripcion"];

      SurveyCreator.StylesManager.applyTheme("winter");
      SurveyCreator.editorLocalization.currentLocale = "es";
      const options = {
        showEmbededSurveyTab: true,
        showJSONEditorTab: true,
        showTestSurveyTab: true,
        showEmbeddedSurveyTab: false,
        generateValidJSON: true,
        showPropertyGrid: false,
      };
      this.surveyCreator = new SurveyCreator.SurveyCreator("surveyCreatorContainerPromociones", options);
      this.surveyCreator.text = JSON.stringify(this.json);
      this.surveyCreator.saveSurveyFunc = this.saveMySurvey;
    });
  }

  saveMySurvey = () => {
    const definicion = this.surveyCreator.text;
    const targetId = this.formularioId || this.promocionId;
    this.data.GuardarFormulario(targetId, definicion, this.agregarsujeto, this.campoidentificador, this.campodescripcion).subscribe(() => {
      this.messageService.add({ severity: 'success', summary: 'Éxito', detail: 'Formulario guardado' });
    });
  };
}

